

import React, { useState, useEffect } from "react";
import {
  Grid,
  Button,
  IconButton,
  useMediaQuery
} from "@mui/material";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SendIcon from "@mui/icons-material/Send";
import VerifiedIcon from '@mui/icons-material/Verified';
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const Dropdown = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  const menuItems = [
    {
      icon: <VerifiedIcon />,
      label: "Verified Profiles",
      url: "/profile/DetaliesDashbord?type=verified-profiles"
    },
    {
      icon: <LightbulbIcon />,
      label: "Suggested Profiles",
      url: "/profile/DetaliesDashbord?type=suggested-profiles"
    },
    {
      icon: <SendIcon />,
      label: "Interests",
      url: "/profile/DetaliesDashbord?type=interests"
    },
    {
      icon: <AccountCircleIcon />,
      label: "Profiles",
      url: "/profile/DetaliesDashbord?type=profiles"
    },
    {
      icon: <SearchIcon />,
      label: "Search",
      url: "/profile/DetaliesDashbord?profilesearch=search-profiles"
    },
    {
      icon: <CameraAltIcon />,
      label: "My albums",
      url: "/profile/DetaliesDashbord?type=my-album"
    }
  ];

  useEffect(() => {
    navigate(menuItems[0].url);
  }, []);

  return (
    <Grid
      container
      sx={{
        backgroundColor: "#c1721f",
        marginTop: { xs: "10px", sm: "5px" },
        padding: { xs: "10px", sm: "0px 0px" },
        width: "100%",
      }}
    >
      {menuItems.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={2}
          key={index}
          sx={{
            borderRight:
              !isMobile && index !== menuItems.length - 1
                ? "2px solid white"
                : "none",
            borderBottom:
              isMobile && index !== menuItems.length - 1
                ? "2px solid white"
                : "none",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
          }}
        >
          <Button
            startIcon={
              <IconButton
                onClick={() => {
                  setSelectedIndex(index);
                  navigate(item.url);
                }}
              >
                {React.cloneElement(item.icon, {
                  sx: {
                    color: selectedIndex === index ? "#c1721f" : "white",
                    width: { xs: "32px", sm:  "16px", md: "18px",  },//xl: "16px", lg: "40px", xxl: "50px"
                    height: { xs: "32px", sm:  "16px", md:  "18px",},
                  }
                })}
              </IconButton>
            }
            onClick={() => {
              setSelectedIndex(index);
              navigate(item.url);
            }}
            sx={{
              color: selectedIndex === index ? "#c1721f" : "white",
              backgroundColor: selectedIndex === index ? "#fff" : "transparent",
              textTransform: "none",
              width: "100%",
              display: "flex",
              justifyContent: { xs: "left", sm: "center" },
              alignItems: "center",
              borderRadius: 0,
              fontSize: { xs: "24px", sm: "15px", md: "16px", xl: "16px",},// lg: "15px", xxl: "40px" 
              fontFamily: '"Inter var"',
              fontWeight: 500,
              lineHeight: '100%',
              px: 1,
              border: selectedIndex === index ? "2px solid #c1721f" : "#c1721f",
              "&:hover": {
                backgroundColor: selectedIndex === index ? "white" : "rgba(255,255,255,0.2)"
              }
            }}
          >
            {item.label}
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default Dropdown;
